/**
 * Checks if the provided value is not `null`, not `undefined`, of type `number` and not a `NaN`
 * @param value The value to check
 * @returns Type predicate value as non nullable `number` type
 */
export const isDefinedNumber = (value: unknown): value is NonNullable<number> => {
  if (value == null) return false;
  if (typeof value !== 'number') return false;
  if (isNaN(value)) return false;
  return true;
};
